import { render } from "./blogByCategory.vue?vue&type=template&id=a9a02af2&scoped=true"
import script from "./blogByCategory.vue?vue&type=script&lang=js"
export * from "./blogByCategory.vue?vue&type=script&lang=js"

import "./blogByCategory.vue?vue&type=style&index=0&id=a9a02af2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a02af2"]])

export default __exports__